/* global Vue, CardSlider, BigCardSlider, useOffers */

import { messagesSpecific } from '../i18n/translations'
import { CreateI18n } from '../i18n/create-i18n'
import OfferSliderCard from './components/OfferSliderCard'
import OfferSliderMultiple from './components/OfferSliderMultiple'

const i18n = CreateI18n(messagesSpecific)
const appElement = document.getElementById('offer-slider-app')
let sliderType = ''
let property = ''
let propertyName = ''
let brand = ''

const OfferSliderApp = Vue.createApp({
  name: 'OfferSliderApp',
  components: { OfferSliderCard, OfferSliderMultiple },
  template: `
<div v-if="error" class="error container">
  <h3>{{ $t('error') }}</h3>
  <p>{{ error }}</p>
</div>

<div v-else-if="offersLoaded">
  <div :class="{
      'card-slider': !bigCardSlider,
      'big-card-slider': bigCardSlider,
      'no-padding-bottom': offers.length < 3,
      'card-slider--no-slider': offers.length < 3,
    }" ref="sliderRef">
    <div class="container" :class="{
        'grid': offers.length == 2,
        'container--fluid': !bigCardSlider,
      }">
      <OfferSliderCard v-if="offers.length === 1" :offer="offers[0]" cardType="unit" :buttonText="buttonText" />
      <div v-else-if="offers.length === 2" v-for="(offer, index) in offers" class="col-12 col-sm-6 col-lg-5 col-xl-4" :class="{
          'offset-lg-1': index === 0,
          'offset-xl-2': index === 0,
        }">
        <OfferSliderCard :offer="offer" :buttonText="buttonText" />
      </div>
      <OfferSliderMultiple v-else :offers="offers" :buttonText="buttonText" :extraClasses="extraClasses" :bigCardSlider="bigCardSlider" />
  </div>
  <div class="swiper-scrollbar" v-if="offers.length > 2 && !bigCardSlider"></div>
</div>
  `,
  setup () {
    const offers = Vue.ref([])
    const offersLoaded = Vue.ref(false)
    const error = Vue.ref('')
    const bigCardSlider = sliderType === 'home' || (sliderType === 'property' && brand === 'collection')
    const buttonText = bigCardSlider ? 'bookNow' : 'discoverMore'
    const sliderRef = Vue.ref(null)

    const extraClasses = Vue.computed(() => offers.value.length === 2
      ? ['width-auto-sm-down', ...(bigCardSlider ? [] : ['negative-cp-sm-down'])]
      : [])

    async function getOffers () {
      const allOffers = await useOffers()

      if (sliderType === 'home') {
        offers.value = allOffers.filter(offer => !!offer.showOnHome)
      } else if (sliderType === 'bundle') {
        offers.value = allOffers.filter(offer =>
          offer.variations && offer.variations.some(
            variation => variation.bundle === property))
      } else if (sliderType === 'property') {
        offers.value = allOffers.filter(offer =>
          offer.variations && offer.variations.some(
            variation => variation.property === `${property}/_index`))
      } else {
        offers.value = allOffers.slice(0, 6)
      }

      if (propertyName) {
        offers.value = offers.value.map(offer => ({ ...offer, link: `${offer.link}?propertyId=${propertyName}` }))
      }

      if (offers.value.length === 0) {
        appElement.parentElement.remove()
      }

      offersLoaded.value = true

      setTimeout(() => {
        if (offers.value.length <= 2) return
        if (!bigCardSlider) {
          CardSlider(sliderRef.value)
          return
        }

        const slider = sliderRef.value.querySelectorAll('.swiper')[0]
        const slides = slider.querySelectorAll('.swiper-slide')
        if (slides) {
          BigCardSlider(slider, slides)
        }
      }, 1)
    }

    Vue.onMounted(async () => {
      getOffers()
    })

    return {
      offers,
      offersLoaded,
      error,
      bigCardSlider,
      buttonText,
      extraClasses,
      sliderRef,
    }
  },
})

if (appElement) {
  sliderType = appElement.dataset.type
  brand = appElement.dataset.brand
  property = appElement.dataset.property
  propertyName = appElement.dataset.propertyname
  OfferSliderApp.use(i18n)
  OfferSliderApp.mount(appElement)
}
